
import './App.css';

import Intro from './components/Intro'
function App() {

    
  
  return (
    <div className="App">
  
      <Intro>
      
      </Intro>
    </div>
  );
}

export default App;
